<template>
  <ui-field
    :id="id"
    :label="label"
    :labelPosition="labelPosition"
    :bottom-margin="bottomMargin"
    :variant="variant"
    :disabled="disabled"
    :error="dirtyError"
  >
    <ui-input
      :id="id"
      :type="type"
      :inputmode="inputmode"
      :readonly="readonly"
      :disabled="disabled"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :min="min"
      :max="max"
      :step="step"
      :pattern="pattern"
      :minlength="minlength"
      :maxlength="maxlength"
      v-on="inputListeners"
    />
  </ui-field>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    type: { type: String, default: "text" },
    inputmode: String,
    label: String,
    variant: {
      type: String,
      validator: val => ["default", "success", "error"].includes(val),
      default: "default"
    },
    error: String,
    labelPosition: String,
    bottomMargin: { type: String },
    value: [String, Number],
    disabled: Boolean,
    min: [String, Number],
    max: [String, Number],
    step: [String, Number],
    minlength: [String, Number],
    maxlength: [String, Number],
    readonly: [String, Boolean],
    required: [String, Boolean],
    pattern: String,
    placeholder: String
  },
  data() {
    return {
      submitted: false,
      modified: false,
      dirty: false
    };
  },
  computed: {
    dirtyError() {
      if (this.dirty || this.submitted) {
        return this.error;
      } else {
        return null;
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.modified = true;
          this.$emit("input", event);
        },
        blur: event => {
          if (this.modified) {
            this.dirty = true;
          }
          this.$emit("blur", event);
        }
      };
    }
  },
  methods: {
    onFormSubmit() {
      this.submitted = true;
    }
  },
  mounted() {
    this.form = this.$el.closest("form");
    this.form?.addEventListener("submit", this.onFormSubmit);
  },
  beforeDestroy() {
    this.form?.removeEventListener("submit", this.onFormSubmit);
  }
};
</script>
